import dagre from 'dagre';

const NODE_WIDTH = 180;
const NODE_HEIGHT = 48;

// Lays out the tag DAG with dagre — unlike GraphLayout.js's DFS layout (built for a
// single-root, branching-but-not-merging workflow diagram), this handles a genuine
// multi-parent DAG where a node can have more than one incoming edge.
export function layoutTags(tags) {
  const graph = new dagre.graphlib.Graph();
  graph.setGraph({ rankdir: 'TB', nodesep: 40, ranksep: 80 });
  graph.setDefaultEdgeLabel(() => ({}));

  tags.forEach((tag) => {
    graph.setNode(String(tag.id), { width: NODE_WIDTH, height: NODE_HEIGHT });
  });

  const edges = [];
  tags.forEach((tag) => {
    (tag.parent_ids || []).forEach((parentId) => {
      graph.setEdge(String(parentId), String(tag.id));
      edges.push({
        id: `e-${parentId}-${tag.id}`,
        source: String(parentId),
        target: String(tag.id),
      });
    });
  });

  dagre.layout(graph);

  const nodes = tags.map((tag) => {
    const { x, y } = graph.node(String(tag.id));
    return {
      id: String(tag.id),
      position: { x: x - NODE_WIDTH / 2, y: y - NODE_HEIGHT / 2 },
      data: { tag },
    };
  });

  return { nodes, edges };
}

// A tag is an orphan when it has zero parents — regardless of whether it has children, since a
// root tag with its own sub-tree still hasn't been placed anywhere in the organization's overall
// hierarchy and is exactly as much in need of review (e.g. attaching under Global, or under a
// broader category) as a brand-new leaf tag. Global is never an orphan: it's the deliberate,
// always-root tag, not something anyone forgot to categorize, and it's rendered specially on the
// canvas rather than in this list.
export function computeOrphanIds(tags) {
  return new Set(
    tags
      .filter((tag) => !tag.is_system)
      .filter((tag) => !tag.parent_ids || tag.parent_ids.length === 0)
      .map((tag) => tag.id),
  );
}
